import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import _ from 'lodash'
import moment from 'moment'
import styles from './Index.css'
import connectToStores from 'alt-utils/lib/connectToStores'
import FormStore from '../../stores/FormStore'
import FormActions from '../../actions/FormActions'
import { hasNoSpecialchars, validEmail, validDate, validPrebooking, dateAfterLimit, validateDateFormat, dateFormats, validPhoneNumber, validLocation } from '../../utils/validate'
import { formDataToDeparture, formDataToDestination } from '../../utils/convert'

import {
  AccountDetails,
  Attributes,
  BookingList,
  ButtonAnimated,
  CarType,
  DateTimePicker,
  DropDownSelect,
  ErrorMessage,
  FixedPriceToggle,
  InfoButton,
  InfoMessage,
  Inputfield,
  Radio,
  Select,
  SearchDestination
} from '../../components'

@connectToStores
@CSSModules(styles, { allowMultiple: true })
export default class Index extends Component {
  static propTypes = {
    accounts: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      number: PropTypes.number
    })),
    allowDirectBook: PropTypes.bool,
    departures: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string
    })),
    destinations: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string
    })),
    directBookMessage: PropTypes.string,
    estimateDeparture: PropTypes.string,
    estimateDestination: PropTypes.string,
    estimateLoading: PropTypes.bool,
    expiresAt: PropTypes.number,
    formData: PropTypes.shape({
      attributes: PropTypes.arrayOf(
        PropTypes.shape({
          checked: PropTypes.bool,
          numberSelect: PropTypes.shape({
            value: PropTypes.number
          })
        })
      ),
      baggage: PropTypes.bool,
      carTypes: PropTypes.arrayOf(
        PropTypes.shape({
          checked: PropTypes.bool
        })
      ),
      departure: PropTypes.shape({
        displayName: PropTypes.string,
        selected: PropTypes.bool
      }),
      destination: PropTypes.shape({
        displayName: PropTypes.string,
        selected: PropTypes.bool
      }),
      email: PropTypes.string,
      flightNumber: PropTypes.string,
      phone: PropTypes.string,
      preBooking: PropTypes.shape({
        date: PropTypes.string,
        edited: PropTypes.bool,
        time: PropTypes.string
      }),
      priceType: PropTypes.string,
      fixedPrice: PropTypes.bool,
      sendSMS: PropTypes.bool,
      location: PropTypes.object,
      name: PropTypes.string
    }),
    hasEstimate: PropTypes.bool,
    user: PropTypes.shape({
      bookingCommissionEnabled: PropTypes.bool,
      bookingCommissionId: PropTypes.string
    }),
    loading: PropTypes.bool,
    locationMessage: PropTypes.string,
    needBaggage: PropTypes.bool,
    needFlightNumber: PropTypes.bool,
    disablePremium: PropTypes.bool,
    isAirport: PropTypes.bool,
    showAccountDetails: PropTypes.bool,
    showDepartureField: PropTypes.bool,
    showInfoMessage: PropTypes.bool,
    validating: PropTypes.bool
   
  }

  static getStores () {
    return [FormStore]
  }

  static getPropsFromStores () {
    return {
      departures: FormStore.getState().departures,
      destinations: FormStore.getState().destinations,
      accounts: FormStore.getState().accounts,
      formData: FormStore.getState().data,
      loading: FormStore.getState().loading,
      validating: FormStore.getState().validating,
      showAccountDetails: FormStore.getState().showAccountDetails,
      showDepartureField: FormStore.getState().showDepartureField,
      showInfoMessage: FormStore.getState().showInfoMessage,
      hasEstimate: FormStore.getState().hasEstimate,
      expiresAt: FormStore.getState().expiresAt,
      estimateLoading: FormStore.getState().estimateLoading,
      estimateDeparture: FormStore.getState().estimateDeparture,
      estimateDestination: FormStore.getState().estimateDestination,
      needFlightNumber: FormStore.getState().needFlightNumber,
      disablePremium: FormStore.getState().disablePremium,
      isAirport: FormStore.getState().isAirport,
      needBaggage: FormStore.getState().needBaggage,
      allowDirectBook: FormStore.getState().allowDirectBook,
      locationMessage: FormStore.getState().locationMessage,
      directBookMessage: FormStore.getState().directBookMessage,
      user: FormStore.getState().user
    }
  }

  constructor (props) {
    super(props)
    this.state = {
      date: this.props.formData.preBooking.date,
      time: this.props.formData.preBooking.time,
      errors: {
        name: '',
        email: '',
        date: '',
        time: '',
        baggage: '',
        flightNumber: '',
        destination: '',
        datePicker: '',        
        dateInvalid: false,
        hoursInvalid: false,
        minutesInvalid: false
      }
    }
    this.prevDateTime = null
  }

  componentDidMount() {
    this.$columnForm = $('#column-form')
    this.$columnBookings = $('#column-bookings')
    this.resize = _.debounce(this._onResize.bind(this), 100)
    $(window).on('resize', this.resize)
    setTimeout(() => {
      this.resize()
    }, 500)
    console.log(this.props.formData)
  }  

  componentDidUpdate (prevProps) {
    // Set focus on location field on booking complete to avoid multiple 
    // bookings when the submit button is focused and holding down enter.
    if (prevProps.loading === true && this.props.loading === false) {
      if (this.props.showDepartureField) {
        this.refs.departureInput.refs.inputField.refs.input.focus()
      }
      else {
        this.refs.destinationInput.refs.inputField.refs.input.focus()
      }
    }
    if (prevProps.isAirport !== this.props.isAirport) {
      setTimeout(() => {
          FormActions.setShowInfoMessage(true)
      }, 5);
    }
    if (prevProps.needFlightNumber !== this.props.needFlightNumber) {
      if (this.props.needFlightNumber) {
        setTimeout(() => {
          //FormActions.setShowInfoMessage(true)

          // If we have changed departure to an airport but a destination is not selected
          // the default location will be used (ie. the hotel / restaurant or similar). 
          // If fixed price is selected we must fetch a new price estimate for the destination.
          if (this.props.formData.fixedPrice && !this.props.formData.destination.selected) {
            this._validateDestination()
            this._estimatePrice()
          }
        }, 5)
      }
      this._validateFlightNumber()
      this._validateName(this.props.formData.name)
      this._validatePhone(this.props.formData.phone)
      this.resize()
    }
    if (prevProps.needBaggage !== this.props.needBaggage) {
      this._validateBaggage()
    }
  }

  _onResize () {
    this.$columnBookings.css('max-height', this.$columnForm.height())
  }

  _onInputChange (type, event) {
    const value = event.target ? event.target.value : event
    const hadDeparture = type === 'departure' && this.props.formData.departure.selected
    const hadDestination = type === 'destination' && this.props.formData.destination.selected

    FormActions.inputChange({ type, value })
    if (type === 'email') {
      this._validateEmail(value)
    }
    if (type === 'name') {
      this._validateName(value)
    }
    if (type === 'phone') {
      this._validatePhone(value)
    }
    if (type === 'departure') {
      this._validateDeparture()
      
      if (!this.props.formData.departure.selected && hadDeparture) {
        console.log('We have cleared departure')
        FormActions.clearDeparture()

        if (this.props.formData.fixedPrice) {
          setTimeout(() => {
            if (!this.props.formData.destination.selected) {
              FormActions.clearPriceEstimate()
              this._validateDestination()
            }
            else {
              this._estimatePrice()
            }
          }, 10)
        }
      }
    }
    if (type === 'destination' && !this.props.formData.destination.selected && hadDestination) {
      console.log('We have cleared destination')
      FormActions.clearDestination()
      this._validateDestination()

      if (this.props.formData.fixedPrice && this.props.needFlightNumber) {
        this._estimatePrice()
      }
      else {
        FormActions.clearPriceEstimate()
      }
    }    
    if (type === 'flightNumber') {
      this._validateFlightNumber()
    }
  }

  _getAccount () {
    const payment = this.props.formData.location.passenger.payment
    return this.props.accounts.find((account) => account.number === payment.account)
  }

  _sendBooking () {
    if (this.props.loading) {
      return
    }
    const data = { ...this.props.formData }
    if (this.props.user && this.props.user.bookingCommissionEnabled && this.props.user.bookingCommissionId) {
      data.bookingCommissionId = this.props.user.bookingCommissionId
    }
    FormActions.book(data)
  }

  _onBookButtonPress () {
    // NOTE: This code is moved to _handleAccountChange
    // const payment = this.props.formData.location.passenger.payment
    // if (payment && payment.account) {
    //   return this._openAccountDetails()
    // }
    if (!this.props.allowDirectBook && !this.props.formData.preBooking.edited) {
      FormActions.displayErrorMessage({ message: this.props.directBookMessage, code: 400 })
      return
    }
    if (!this._isButtonDisabled()) {
      this._sendBooking()
    }
  }

  _openAccountDetails () {
    FormActions.showAccountDetails(true)
  }

  _onCloseAccountClick () {
    FormActions.validateAccount(this.props.formData)
  }

  _onCancelAccountClick () {    
    this.refs.dropdownSelect.resetSelect()
    FormActions.showAccountDetails(false)
  }

  _isButtonDisabled () {
    if (this.props.formData.fixedPrice && (!this.props.hasEstimate || this.props.estimateLoading)) {
      return true
    }    
    if (this.props.showDepartureField && this.props.formData.departure.displayName !== '' && !this.props.formData.departure.selected) {
      return true
    }
    const errors = this.state.errors ? this.state.errors : {}
    let isDisabled = false
    Object.keys(errors).forEach(key => {
      if (errors[key] && (errors[key] !== '' && errors[key] !== false)) {
        isDisabled = true
      }
    })
    return isDisabled
  }

  _showDropDown () {
    return this.props.accounts.length > 0
  }

  _validateEmail (string) {
    const errors = this.state.errors
    if (string !== '' && !validEmail(string)) {
      errors.email = 'Ogiltig e-postadress.'
    } else {
      errors.email = ''
    }
    this.setState({ errors })
  }

  _validateName (string) {
    const errors = this.state.errors
    if (!hasNoSpecialchars(string)) {
      errors.name = 'Endast bokstäver, siffror och mellanslag.'
    } else if (this.props.needFlightNumber && string === '') {
      errors.name = 'Namn är obligatoriskt.'
    } else {
      errors.name = ''
    }
    this.setState({ errors })
  }

  _validatePhone (string) {
    const errors = this.state.errors
    if (this.props.needFlightNumber && string === '') {
      errors.phone = 'Telefonnummer är obligatoriskt.'
    } else if (this.props.needFlightNumber && !validPhoneNumber(string)) {
      errors.phone = 'Felaktigt telefonnummer.'
    } else {
      errors.phone = ''
    }
    this.setState({ errors })
  }

  _validateDeparture () {
    const errors = this.state.errors
    if (this.props.formData.fixedPrice && this.props.formData.departure.displayName !== '' && !this.props.formData.departure.selected) {
      errors.departure = 'Fastpris kräver upphämtningsplats.'
    } else {
      errors.departure = ''
    }
    this.setState({ errors })
  }

  _validateDestination () {
    const errors = this.state.errors
    if (this.props.formData.fixedPrice && !this.props.formData.destination.selected && !this.props.needFlightNumber) {
      errors.destination = 'Fastpris kräver destination.'
    } else {
      errors.destination = ''
    }
    this.setState({ errors })
  }

  _validateFlightNumber () {
    const errors = this.state.errors
    if (this.props.needFlightNumber && this.props.formData.flightNumber === '') {
      errors.flightNumber = 'Flightnummer är obligatoriskt.'
    } else {
      errors.flightNumber = ''
    }
    this.setState({ errors })
  }
  
  _validateBaggage () {
    const errors = this.state.errors
    if (this.props.needBaggage && this.props.formData.baggage === null) {
      errors.baggage = 'Ja / nej är obligatoriskt.'
    } else {
      errors.baggage = ''
    }
    this.setState({ errors })
  }

  _validateDate (date) {
    const errors = this.state.errors
    const dateAfter = dateAfterLimit(date)
    if (!validDate(date) || dateAfter) {      
      errors.date = dateAfter ? 'Du kan boka max 90 dagar framåt' : 'Datum passerat'
    } else {
      errors.date = ''
      errors.time = ''
    }
    this.setState({ errors })
  }

  _validateTime (date, time) {
    const errors = this.state.errors
    if (!validDate(date, time) && this.state.errors.date === '') {
      errors.time = 'Tid passerad'
    } 
    else if (this.props.formData.preBooking.edited && !validPrebooking(date, time)) {
      errors.time = 'Förbokning kan göras tidigast 30 minuter i förväg'
    }
    else {
      errors.time = ''
    }
    this.forceUpdate()

    if (this.props.formData.fixedPrice) {
      this._estimatePrice()
    }    
  }

  _invalidTimePart (value, min, max) {
    const val = parseInt(value, 10)
    return (isNaN(val) || val < min || val > max)    
  }

  _onTimePartBlur (hours, minutes) {
    const errors = this.state.errors

    errors.hoursInvalid = this._invalidTimePart(hours, 0, 23)
    errors.minutesInvalid = this._invalidTimePart(minutes, 0, 59)

    if (!errors.hoursInvalid && !errors.minutesInvalid) {
      this._onTimeChange(_.padStart(hours, 2, '0') + ':' + _.padStart(minutes, 2, '0'))
      errors.time = ''
    }
    else {
      errors.time = 'Felaktig tid'
    }

    this.setState({ errors: errors })
  }

  _onTimePartChange (value) {
    FormActions.timeChange({ value })
    this.setState({ time: value })
    // NOTE: We skip the validation here and instead run the func below with validation onBlur
  }

  _onTimeChange (value) {
    FormActions.timeChange({ value })
    this.setState({ time: value }, () => {
      this._validateTime(this.state.date, value)
    })    
  }

  _onDateChange (date) {
    if (date !== null) {
      const errors = this.state.errors
      let isValidFormat = true

      // Datepicker onBlur passes an event
      if (date.target) {
        isValidFormat = validateDateFormat(date.target.value)
        if (isValidFormat) {
          date = moment(date.target.value, dateFormats(), true)
          errors.date = ''
          errors.dateInvalid = false
        }
        else {
          errors.date = 'Felaktigt datum'
          errors.dateInvalid = true
        }
      }

      // ...but onChange passes a moment()
      if (isValidFormat) {
        // TODO: Validate date not passed or > 30 days
        const value = date.format('YYYY-MM-DD')
        FormActions.dateChange({ value })
        this.setState({ date: value }, () => {
          this._validateDate(value)
          this._validateTime(value, this.state.time)
        })
      }

      this.setState({ errors: errors })
    }
  }

  _onDestinationSelected (type, destination) {
    FormActions.destinationSelected(type, destination)
    // Check if we got a complete location
    if (validLocation(destination)) {
      if (destination.locationInformation === undefined) {
        FormActions.fetchLocationInfo(type, destination)
      }
      if (type === 'departure') {
        console.log('We have a selected departure!')
        this._validateDeparture()
      }
      if (type === 'destination') {
        console.log('We have a selected destination!')
        this._validateDestination()
      }
      if (this.props.formData.fixedPrice) {
        this._estimatePrice()
      }
    }
  }

  _onSearch (type, destination) {
    // TODO: v3 add support for regions
    FormActions.searchDestination(type, destination, null, this.props.formData[type].city)
  }

  _onToggleSendSMS () {
    FormActions.setSendSMS(!this.props.formData.sendSMS) 
  }

  _carTypeIsTaxiOrBigCar () {
    return this.props.formData.carTypes[0].checked || this.props.formData.carTypes[2].checked
  }

  _onToggleCheckbox (attributeName) {
    FormActions.selectAttribute(attributeName)
  }

  _onNumberSelectPressed (attributeName, event) {
    event.preventDefault()
    FormActions.selectAttributeValue(attributeName)
  }

  _onAccountPasswordChange (value) {
    FormActions.accountPasswordChange(value)
  }

  _onAccountReferenceChange (value) {
    FormActions.referenceChange(value)
  }

  _handleAccountChange (value) {
    FormActions.accountChange({ value })
    const payment = this.props.formData.location.passenger.payment
    if (payment && payment.account) {
      this._openAccountDetails()
    }    
  }

  _estimatePrice () {
    console.log('_estimatePrice')
    if (!this.state.errors.dateInvalid && !this.state.errors.hoursInvalid && !this.state.errors.minutesInvalid && 
      (this.props.formData.destination.selected || this.props.needFlightNumber)) {
      if (!this.props.hasEstimate 
        || Date.now() > this.props.expiresAt 
        || (this.props.formData.preBooking.date + this.props.formData.preBooking.time !== this.prevDateTime)
        || this.props.showDepartureField && this.props.estimateDeparture !== JSON.stringify(formDataToDeparture(this.props.formData))
        || this.props.showDepartureField && this.props.estimateDestination !== JSON.stringify(formDataToDestination(this.props.formData))) {
        this.prevDateTime = this.props.formData.preBooking.date + this.props.formData.preBooking.time
        const data = { ...this.props.formData }
        if (this.props.user && this.props.user.bookingCommissionEnabled && this.props.user.bookingCommissionId) {
          data.bookingCommissionId = this.props.user.bookingCommissionId
        }
        console.log('Fetch estimate!')
        FormActions.estimatePrice(data)
      }
    }
  }

  _onFixedPriceChange (value) {
    FormActions.setFixedPrice(value)
    if (this.props.showDepartureField) {
      this._validateDeparture()
    }
    this._validateDestination()
    if (value) {
      this._estimatePrice()
    } 
    else {
      FormActions.killEstimateTimer()
    }
  }

  _onBaggageChange (value) {
    FormActions.setBaggage(value === 'Ja')
    this._validateBaggage()
  }

  _onLocationClick () {
    this.refs.departureInput.refs.inputField.refs.input.value = ''
    this._onInputChange('departure', '')
  }

  render () {
    const { formData, departures, destinations } = this.props
    const payment = formData.location.passenger.payment
    const destinationText = this.props.showDepartureField ? 'Till' : 'Destination'
    const pickupText = this.props.needFlightNumber ? 'Landingstid' : 'Hämtningstid'
    const destinationPlaceholderText = this.props.needFlightNumber ? formData.location.displayName : 'Sök adress'
    const locationClassnames = this.props.showDepartureField ? 'location-name location-name-clickable' : 'location-name'
    const enableSMS = formData.phone !== ''

    return (
      <div styleName="index">
        <div id="column-form" styleName="column form">
          <div styleName="column-padding">
            <div onClick={this._onLocationClick.bind(this)} styleName={locationClassnames}>
              <div className="ion-location" styleName="location-icon" />
              <span styleName="location-text">{formData.location.name ? formData.location.name : 'Testmiljö'}</span>
            </div>
            <div styleName="input-container">
              {this.props.showDepartureField && <div style={{ position: 'relative' }} styleName="searchfield">
                {this.props.locationMessage && <InfoButton />}
                <SearchDestination
                  errorMessage={this.state.errors.departure}
                  isSearching={this.isSearching}
                  onChange={this._onInputChange.bind(this, 'departure')}
                  onDestinationSelected={this._onDestinationSelected.bind(this, 'departure')}
                  placeholder={formData.location.displayName}
                  ref="departureInput"
                  results={departures}
                  search={this._onSearch.bind(this, 'departure')}
                  selected
                  streetNumberToolTipVisible={formData.departure.streetNumberToolTipVisible}
                  redirectMessageVisable={formData.departure.redirectMessageVisable}
                  redirectMessage={formData.departure.redirectMessage}
                  title="Från"
                  value={formData.departure.displayName} 
                />
              </div>}
              <div styleName="searchfield">
                <SearchDestination
                  errorMessage={this.state.errors.destination}
                  isSearching={this.isSearching}
                  onChange={this._onInputChange.bind(this, 'destination')}
                  onDestinationSelected={this._onDestinationSelected.bind(this, 'destination')}
                  placeholder={destinationPlaceholderText}
                  ref="destinationInput"
                  results={destinations}
                  search={this._onSearch.bind(this, 'destination')}
                  streetNumberToolTipVisible={formData.destination.streetNumberToolTipVisible}
                  redirectMessageVisable={formData.destination.redirectMessageVisable}
                  redirectMessage={formData.destination.redirectMessage}
                  title={destinationText}
                  value={formData.destination.displayName} 
                />
              </div>
            </div>
            <div styleName="dateTimeRow">
              <DateTimePicker
                date={formData.preBooking.date}
                dateInvalid={this.state.errors.dateInvalid}
                errorMessageDate={this.state.errors.date}
                errorMessageTime={this.state.errors.time}
                hoursInvalid={this.state.errors.hoursInvalid}
                minutesInvalid={this.state.errors.minutesInvalid}
                onDateChange={this._onDateChange.bind(this)}
                onTimeBlur={this._onTimePartBlur.bind(this)}
                onTimeChange={this._onTimeChange.bind(this)}
                onTimePartChange={this._onTimePartChange.bind(this)}
                time={formData.preBooking.time}
                title={pickupText} 
              />
              {this.props.needFlightNumber && <div>
                <Inputfield
                  errorMessage={this.state.errors.flightNumber}
                  inputClasses="flightNumber"
                  label="Flightnr."
                  maxLength={8}
                  onChange={this._onInputChange.bind(this, 'flightNumber')}
                  placeholder=""
                  size={13}
                  value={formData.flightNumber} />
              </div>}
              {this.props.needBaggage && <div style={{ marginLeft: '15px' }}>
                <Radio 
                  errorMessage={this.state.errors.baggage}
                  name="bagage"
                  onChange={this._onBaggageChange.bind(this)}
                  options={['Ja', 'Nej']}
                  title="Bagage"
                />
              </div>}
            </div>
            <div styleName="passengerExtras">
              <div styleName="passengerField">
                <Inputfield
                  errorMessage={this.state.errors.name}
                  label="Namn"
                  onChange={this._onInputChange.bind(this, 'name')}
                  placeholder="Namn på resenär"
                  value={formData.name} />
              </div>
              <div styleName="passengerField">
                <Inputfield
                  errorMessage={this.state.errors.email}
                  label="Bokningsbekräftelse"
                  onChange={this._onInputChange.bind(this, 'email')}
                  placeholder="E-postadress"
                  value={formData.email}
                />
              </div>
            </div>
            <div styleName="passengerExtras">
              <div styleName="passengerField">
                <Inputfield
                  errorMessage={this.state.errors.phone}
                  label="Mobilnummer"
                  onChange={this._onInputChange.bind(this, 'phone')}
                  placeholder="Resenärens mobilnummer"
                  value={formData.phone}
                />
              </div>
              <div styleName={`${!enableSMS ? 'disabled' : ''} smsCheckbox`}>
                <Select
                  checked={formData.sendSMS}
                  disabled={!enableSMS}
                  name="sendSMS"
                  onClick={this._onToggleSendSMS.bind(this)} />
                <label>Ankomstinfo via SMS</label>
              </div>
            </div>
            <div styleName="passengerField">
              <Inputfield
                label="Meddelande"
                onChange={this._onInputChange.bind(this, 'message')}
                placeholder="Meddelande till förare"
                maxLength={30}
                value={formData.message} />
            </div>
            <CarType
              carTypes={formData.carTypes}
              fixedPrice={formData.fixedPrice}
              premiumIsDisabled={this.props.disablePremium}
              taxiIsDisabled={false} />
            <FixedPriceToggle 
              checked={formData.fixedPrice}
              estimateLoading={this.props.estimateLoading}
              onChange={this._onFixedPriceChange.bind(this)} />  
            <Attributes
              attributes={formData.attributes}
              disabled={!this._carTypeIsTaxiOrBigCar()}
              onNumberSelectPressed={this._onNumberSelectPressed.bind(this)}
              onToggleCheckbox={this._onToggleCheckbox.bind(this)} />
            {this._showDropDown() && <DropDownSelect
              label="Boka med konto"
              onChange={this._handleAccountChange.bind(this)}
              options={this.props.accounts.map(account => {
                return {
                  label: account.number.toString(),
                  value: account.number
                }
              })}
              placeholder="Välj konto"
              ref="dropdownSelect"
              value={payment ? payment.account : null} />}
            {this.props.showAccountDetails && <AccountDetails
              account={this._getAccount()}
              onAccountPasswordChange={this._onAccountPasswordChange.bind(this)}
              onAccountReferenceChange={this._onAccountReferenceChange.bind(this)}
              onCancelClick={this._onCancelAccountClick.bind(this)} 
              onOkClick={this._onCloseAccountClick.bind(this)}
              validating={this.props.validating}
            />}
          </div>
          <ButtonAnimated
            disabled={this._isButtonDisabled()}
            loading={this.props.loading}
            onClick={this._onBookButtonPress.bind(this)}
            status="default"
            text={this.props.loading ? 'Bokar' : 'Boka taxi'} 
          />
        </div>

        <div id="column-bookings" styleName="column bookings">
          <div styleName="column-padding">
            <BookingList />
          </div>
        </div>

        <ErrorMessage
          errorType={formData.error.code}
          message={formData.error.message} />

        {this.props.showInfoMessage &&
          <InfoMessage
            instructions={'<strong>Observera!</strong>\r\nNedanstående information angående upphämtning är viktig att förmedla till resenären. Fyll i en e-postaddress innan ni bokar för att skicka en bokningsbekräftelse.'}
            message={this.props.locationMessage} />}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Index/Index.js